<template>
  <div class="enrolling-log-item"
       v-loading="loading"
       :element-loading-text="logType.name + '日志加载中...'">
    <AppScrollbar ref="logItemScrollbar" style="height: 100%">
      <div class="enrolling-log-item-cont"
           v-infinite-scroll="loadMoreLogList"
           infinite-scroll-disabled="noMore"
           infinite-scroll-distance="50"
           infinite-scroll-immediate-check="false"
           infinite-scroll-listen-for-event="loadMoreEvent">
        <template v-if="logList">
          <el-timeline v-if="logList.length > 0">
            <el-timeline-item v-for="(log, index) in logList"
                              :key="index"
                              :timestamp="log.operateDate"
                              placement="top">
              <EnrollingLogItemWrap :log="log"/>
            </el-timeline-item>
          </el-timeline>
          <Hint v-else
                v-show="noMore && !loadingMore">
            <span>{{logType.name}}日志为空</span>
          </Hint>
          <div class="enrolling-log-item-loader" v-if="!noMore">
            <span v-if="loadingMore">
              <i class="el-icon-loading"></i>
              <span>更多数据加载中...</span>
            </span>
            <span v-else>
              <a class="theme-text" @click="loadMoreLogList">加载更多...</a>
            </span>
          </div>
        </template>
        <Hint v-else
              v-show="!loading">
          <span>{{logType.name}}日志加载失败</span>
          <a class="theme-text" @click="loadLogList">重新加载</a>
        </Hint>
      </div>
    </AppScrollbar>
  </div>
</template>
<script>
import infiniteScroll from 'vue-infinite-scroll'
import AppScrollbar from '../../../../../../elements/AppScrollbar'
import Hint from '../../../../../../elements/Hint'
import EnrollingLogItemWrap from './main'
import { addResizeListener, removeResizeListener } from 'element-ui/lib/utils/resize-event'
export default {
  name: 'PlatformLogItem',
  components: {AppScrollbar, Hint, EnrollingLogItemWrap},
  directives: {infiniteScroll},
  props: {
    rowData: {
      type: Object,
      required: true
    },
    logType: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      loading: false,
      logList: null,
      loadingMore: false,
      noMore: true
    }
  },
  methods: {
    queryLogList () {
      let prevId
      if (this.logList && this.logList.length > 0) {
        prevId = this.logList[this.logList.length - 1].id
      }
      return this.$ajax({
        url: '/workspace/manager/enrolling/query/queryLogs',
        method: 'post',
        data: this.$qs.stringify({
          id: this.rowData.id,
          prevId: prevId || '',
          logTypeCode: this.logType.code
        })
      })
    },
    loadLogList () {
      this.loading = true
      this.queryLogList().then(response => {
        if (response.data) {
          this.logList = response.data['logs'] || []
          this.noMore = response.data['noMore']
          this.handleLoadMoreEvent()
        }
      }, () => {
        this.$message.error('请求日志数据失败')
      }).finally(() => {
        this.loading = false
      })
    },
    loadMoreLogList () {
      this.loadingMore = true
      this.queryLogList().then(response => {
        if (response.data) {
          let logs = response.data['logs']
          if (logs && logs.length > 0) {
            this.logList = this.logList.concat(logs)
          }
          this.noMore = response.data['noMore']
          this.handleLoadMoreEvent()
        }
      }, () => {
        this.$message.error('请求日志数据失败')
      }).finally(() => {
        this.loadingMore = false
      })
    },
    bindScrollEvent () {
      let scrollbar = this.$refs['logItemScrollbar']
      if (scrollbar) {
        let appScrollbar = scrollbar.$refs['appScrollbar']
        let resize = appScrollbar.$refs['resize']
        addResizeListener(resize, this.handleLoadMoreEvent)
      }
    },
    unbindScrollEvent () {
      let scrollbar = this.$refs['logItemScrollbar']
      if (scrollbar) {
        let appScrollbar = scrollbar.$refs['appScrollbar']
        let resize = appScrollbar.$refs['resize']
        removeResizeListener(resize, this.handleLoadMoreEvent)
      }
    },
    handleLoadMoreEvent () {
      this.$nextTick(() => this.$emit('loadMoreEvent'))
    }
  },
  mounted () {
    this.bindScrollEvent()
    this.loadLogList()
  },
  beforeDestroy () {
    this.unbindScrollEvent()
  }
}
</script>
<style lang="scss">
.enrolling-log-item {
  position: relative;
  height: 100%;
  .el-scrollbar {
    .el-scrollbar__wrap {
      overflow-x: hidden;
    }
  }
  .enrolling-log-item-cont {
    padding: 20px;
    .layout-hint {
      height: 300px;
      a {
        cursor: pointer;
      }
    }
    & > .enrolling-log-item-loader {
      margin-top: 10px;
      height: 40px;
      font-size: 13px;
      text-align: center;
      line-height: 40px;
      i {
        font-size: 18px;
        vertical-align: -2px;
      }
      a {
        cursor: pointer;
        text-decoration: none;
      }
    }
  }
}
</style>
